module.exports = __webpack_public_path__ + "img/P2.6901d855.png";